import type { FC } from "react";

import styles from "./HeaderSection.module.scss";

export type HeaderSectionProps = {
  dialogTitle: string;
  dialogDescription: string;
  logoUrl?: string;
  logoAlt?: string;
};

export const HeaderSection: FC<HeaderSectionProps> = ({ dialogDescription, dialogTitle, logoAlt, logoUrl }) => {
  return (
    <header className={styles.headerSectionWrapper}>
      {!!logoUrl && !!logoAlt && <img src={logoUrl} alt={logoAlt} className={styles.logo} />}
      <h2 className={styles.title}>{dialogTitle}</h2>
      <p className={styles.description}>{dialogDescription}</p>
    </header>
  );
};
